// 报表接口
import $http from '@/resource';

const $api = {};

/**
 * 获取报表详情
 *
 * @author zhangkaidong 2020-07-02 14:06:15
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url /companys/report-company-detail/
 */
$api.getReportCompanyDetail = async (id) => {

    let dict ={'id':id}
    let url = `companys/report-company-detail/`;
    let res = await $http.get(url,{params:dict});
    return res;
}
/**
 * 获取年报详情
 *
 * @author zhangkaidong 2020-07-02 14:06:15
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url /reports/annual-report
 */
$api.getAnnualReport = async (id) => {

    let dict ={'id':id}
    let url = "reports/annual-report";
    let res = await $http.get(url,{params:dict});
    return res;
}

/**
 * 获取月报详情
 *
 * @author zhangkaidong 2020-07-02 14:06:15
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url reports/monthly-report
 */
$api.getMonthlyReport = async (id) => {

    let dict ={'id':id}
    let url = "reports/monthly-report";
    let res = await $http.get(url,{params:dict});
    return res;
}


/**
 * 获取编辑记录
 *
 * @author zhangkaidong 2020-07-13 09:30:59
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url  /reports/{id}/log
 */
$api.getReportLog = async (id,data) => {


  let url = `/reports/${id}/log`;
  let res = await $http.get(url,{params:data});
  return res;

}


/**
 * 提交审批意见
 *
 * @author zhangkaidong 2020-07-13 09:30:59
 *
 * @method PATCH
 *
 * @returns {Promise<*>}
 *
 * @url  /reports/${id}/approval
 */
$api.pushApproval = async (id,data) => {

  let url = `/reports/${id}/approval`;
  let res = await $http.patch(url,data);
  return res;

}
/**
 * 提交审批意见
 *
 * @author zhangkaidong 2020-07-13 09:30:59
 *
 * @method PATCH
 *
 * @returns {Promise<*>}
 *
 * @url  /reports/${id}/approval
 */
$api.getSameReport = async (id) => {

    let url = `/reports/${id}/getSameReport`;
    let res = await $http.get(url);
    return res;

}

/**
 * 月报年报审批判断是否重复
 *
 * @author zty 2020-07-13 09:30:59
 *
 * @method PATCH
 *
 * @returns {Promise<*>}
 *
 * @url  /reports/${id}/approval
 */
$api.getSameReport = async (id,data) => {

    let url = `/reports/${id}/getSameReport`;
    let res = await $http.get(url,data);
    return res;

}

/**
 * 佛高新报表上传
 *
 * @author zhangkaidong 2020-07-17 11:07:03
 *
 * @method POST
 *
 * @returns {Promise<*>}
 *
 * @url  reports/upload
 */
$api.pushReportData = async (data) => {
    let url = `reports/upload`;
    let res = await $http.post(url,data);
    return res;
}
/**
 * 佛高新报表上传验重
 *
 * @author zhangkaidong 2020-07-17 11:07:03
 *
 * @method POST
 *
 * @returns {Promise<*>}
 *
 * @url  reports/upload
 */
$api.uploadReportRepeat = async (data) => {
    let url = `reports/uploadRepeat`;
    let res = await $http.post(url,data);
    return res;
}

/**
 * 获取企业报表列表
 *
 * @author zhangkaidong 2020-07-13 09:30:59
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url /reports/list
 */
$api.getCompanyReportList = async (data) => {

    let url = `/reports/list`;
    let res = await $http.get(url,{params:data});
    return res;

}

/**
 * 添加附件
 *
 * @param {string} itemId 项目id
 *
 * @param {object} postData 待提交的数据
 *
 * @date 2018-12-5 15:03:08
 *
 * @return {Promise}
 */
$api.uploadFile = (id = '', postData = {}) => {
  if (!id || !postData) {
    return false
  }
  const url = `companys/${id}/file`
  const promise = new Promise((resolve) => {
    $http.patch(url, postData).then((response) => {
      resolve(response)
    })
  })
  return promise
}


/**
 * 根据类型获取单文件下载地址
 *
 * @param {string} type 类型
 * @param {object} param 路由携带参数
 *
 * @date 2018-10-11 14:36:30
 *
 * @return {string}
 */
$api.getEnterDownloadUrlByType =  (type,param={})=>{

    let list = {
        //项目附件
        "itemFile"   :  `item/${param.id}/attachment?fileId=${param.fileId}`,
        "carrierFile":  `carrier/${param.id}/attachment?fileId=${param.fileId}`,
        "companyFile":  `companyFile/${param.id}/attachment?fileId=${param.fileId}`,
        "commonFile" :  `plugin/common-attachment?fileId=${param.fileId}`,
    };

    if(!type || !list[type]){
        return "";
    }

    return list[type];
};


/**
 * 导出Office文件
 *
 * @param {string} url 请求地址
 * @param {function} callback 回调操作函数
 * @param {string} name 下载文件名[带后缀]
 *
 * @date 2018-9-28 16:16:23
 *
 * @returns {Promise<any>}
 */
$api.downloadEnterOfficeFile =  (url,callback=()=>{},name="") => {
    const promise = new Promise(resolve => {
        $http.get(url, {responseType: 'blob'}).then(response => {
            callback();
            if (!response || response.size === 0) {
                utils.notice("下载失败,超时或文件不存在，请重试", 'error');
            } else {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                name = name === "" ? Date.parse(new Date())+".xls" : name;
                // link.click();
                link.setAttribute('download', name);
                // document.body.appendChild(link);
                link.click();
            }
        })
    });
    return promise;
};

export default $api;



// WEBPACK FOOTER //
// ./src/service/enterprise/report.js